<nz-card style="margin-bottom: 10px;">
  <nz-spin [nzSpinning]="isSpinning">
    <nz-tabset [(nzSelectedIndex)]="activeTabIndex" class="custom-tabset">
      <nz-tab [nzTitle]="vendorTab"></nz-tab>
      <nz-tab [nzTitle]="customerTab"></nz-tab>
      <nz-tab [nzTitle]="guestVendorTab"></nz-tab>
      <nz-tab [nzTitle]="guestCustomerTab"></nz-tab>
    </nz-tabset>

    <div class="conditions-wrapper">
      <!-- 来宾厂商条件区 -->
      <form nz-form *ngIf="toNumber(activeTabIndex) === 2" [formGroup]="guestVendorForm">
        <div class="row-with-spacing">
          <div class="field-block inline-field">
            <label class="inline-label">{{'VendorCode' | translate}}</label>
            <input nz-input formControlName="vendorCode" />
          </div>
          <div class="field-block inline-field">
            <label class="inline-label">{{'VendorName' | translate}}</label>
            <input nz-input formControlName="vendorName" />
          </div>
          <div class="field-block inline-field">
            <label class="inline-label">{{'Account' | translate}}</label>
            <input nz-input formControlName="account" />
          </div>
          <div class="field-block inline-field short">
            <label class="inline-label">{{'ContactList.IdmAccountStatus' | translate}}</label>
            <nz-select formControlName="fndaAccountStatus" nzAllowClear nzPlaceHolder="ALL">
              <nz-option nzLabel="ALL" nzValue=""></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountLocked' | translate" nzValue="locked"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountEntraInvalid' | translate" nzValue="entraExpired"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountWaitingVendor' | translate" nzValue="waitingVendor"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountActive' | translate" nzValue="active"></nz-option>
            </nz-select>
          </div>
          <div class="field-block inline-field short">
            <label class="inline-label">{{'ContactList.PermissionStatus' | translate}}</label>
            <nz-select formControlName="accountStatus" nzAllowClear nzPlaceHolder="ALL">
              <nz-option nzLabel="ALL" nzValue=""></nz-option>
              <nz-option [nzLabel]="'ContactList.Enabled' | translate" nzValue="valid"></nz-option>
              <nz-option [nzLabel]="'ContactList.Disabled' | translate" nzValue="invalid"></nz-option>
              <nz-option [nzLabel]="'ContactList.TransferredToOfficial' | translate" nzValue="formal"></nz-option>
            </nz-select>
          </div>
          <button nz-button nzType="primary" type="button" class="default-button" [disabled]="loading"
            (click)="onSearchGuestVendor()">{{ loading ? ('ContactList.Searching' | translate) : ('ContactList.Search'
            |
            translate) }}</button>
          <button nz-button nzType="default" type="button" class="default-button" style="margin-left:8px;"
            [disabled]="loading || (guestVendorList?.length||0)===0" (click)="onExportGuestVendor()"><span nz-icon
              nzType="export" nzTheme="outline"></span>{{ 'Export' | translate }}</button>

        </div>
      </form>
      <!-- 来宾客户条件区 -->
      <form nz-form *ngIf="toNumber(activeTabIndex) === 3" [formGroup]="guestCustomerForm">
        <div class="row-with-spacing">
          <div class="field-block inline-field">
            <label class="inline-label">{{'ContactList.CustomerCode' | translate}}</label>
            <input nz-input formControlName="customerCode" />
          </div>
          <div class="field-block inline-field">
            <label class="inline-label">{{'ContactList.CustomerName' | translate}}</label>
            <input nz-input formControlName="customerName" [nzAutocomplete]="autoVendorGC"
              (input)="onVendorInput($event.target.value)" />
            <nz-autocomplete #autoVendorGC>
              <nz-auto-option *ngFor="let option of vendorOptionList" [nzValue]="option.supplierName">
                {{ option.supplierId }} - {{ option.supplierName }}
              </nz-auto-option>
            </nz-autocomplete>
          </div>
          <div class="field-block inline-field">
            <label class="inline-label">{{'Account' | translate}}</label>
            <input nz-input formControlName="account" />
          </div>
          <div class="field-block inline-field short">
            <label class="inline-label">{{'ContactList.IdmAccountStatus' | translate}}</label>
            <nz-select formControlName="fndaAccountStatus" nzAllowClear nzPlaceHolder="ALL">
              <nz-option nzLabel="ALL" nzValue=""></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountLocked' | translate" nzValue="locked"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountEntraInvalid' | translate" nzValue="entraExpired"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountWaitingVendor' | translate" nzValue="waitingVendor"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountActive' | translate" nzValue="active"></nz-option>
            </nz-select>
          </div>
          <div class="field-block inline-field short">
            <label class="inline-label">{{'ContactList.PermissionStatus' | translate}}</label>
            <nz-select formControlName="accountStatus" nzAllowClear nzPlaceHolder="ALL">
              <nz-option nzLabel="ALL" nzValue=""></nz-option>
              <nz-option [nzLabel]="'ContactList.Enabled' | translate" nzValue="valid"></nz-option>
              <nz-option [nzLabel]="'ContactList.Disabled' | translate" nzValue="invalid"></nz-option>
              <nz-option [nzLabel]="'ContactList.TransferredToOfficial' | translate" nzValue="formal"></nz-option>
            </nz-select>
          </div>
          <div class="condition-actions">
            <button nz-button nzType="primary" type="button" class="default-button" [disabled]="loading"
              (click)="onSearchGuestCustomer()">{{ loading ? ('ContactList.Searching' | translate) :
              ('ContactList.Search'
              |
              translate) }}</button>

            <button nz-button nzType="default" type="button" class="default-button" style="margin-left:8px;"
              [disabled]="loading || (guestCustomerList?.length||0)===0" (click)="onExportGuestCustomer()"> <span
                nz-icon nzType="export" nzTheme="outline"></span>{{ 'Export' | translate }}</button>
          </div>
        </div>
      </form>
      <!-- 供應商 厂商条件区：与其它条件区保持一致的行内布局，可自动换行 -->
      <form nz-form *ngIf="toNumber(activeTabIndex) === 0" [formGroup]="vendorForm">
        <div class="row-with-spacing">
          <!-- <div class="field-block inline-field">
          <label class="inline-label">{{'ContactList.Site' | translate}}</label>
          <nz-select formControlName="site" nzAllowClear nzPlaceHolder="ALL">
            <nz-option nzLabel="ALL" nzValue=""></nz-option>
            <nz-option *ngFor="let option of SiteList" [nzLabel]="option"
              [nzValue]="option"></nz-option>
          </nz-select>
        </div> -->
          <div class="field-block inline-field">
            <label class="inline-label">{{'VendorCode' | translate}}</label>
            <input nz-input formControlName="vendorCode" />
          </div>
          <div class="field-block inline-field">
            <label class="inline-label">{{'VendorName' | translate}}</label>
            <input nz-input formControlName="vendorName" />
          </div>
          <div class="field-block inline-field">
            <label class="inline-label">{{'Account' | translate}}</label>
            <input nz-input formControlName="account" />
          </div>
          <!-- 賬號狀態
         先註解掉，等後端確認需求再打開 -->
          <div class="field-block inline-field short">
          <label class="inline-label">{{'ContactList.IdmAccountStatus' | translate}}</label>
          <nz-select formControlName="fndaAccountStatus" nzAllowClear nzPlaceHolder="ALL">
            <nz-option nzLabel="ALL" nzValue=""></nz-option>
            <nz-option [nzLabel]="'ContactList.AccountLocked' | translate" nzValue="locked"></nz-option>
            <nz-option [nzLabel]="'ContactList.AccountEntraInvalid' | translate" nzValue="entraExpired"></nz-option>
            <nz-option [nzLabel]="'ContactList.AccountWaitingVendor' | translate" nzValue="waitingVendor"></nz-option>
            <nz-option [nzLabel]="'ContactList.AccountActive' | translate" nzValue="active"></nz-option>
          </nz-select>
        </div>
          <div class="field-block inline-field short">
            <label class="inline-label">{{'ContactList.PermissionStatus' | translate}}</label>
            <nz-select formControlName="accountStatus" nzAllowClear nzPlaceHolder="ALL">
              <nz-option nzLabel="ALL" nzValue=""></nz-option>
              <nz-option [nzLabel]="'ContactList.Enabled' | translate" nzValue="valid"></nz-option>
              <nz-option [nzLabel]="'ContactList.Disabled' | translate" nzValue="invalid"></nz-option>
              <nz-option [nzLabel]="'ContactList.TransferredToOfficial' | translate" nzValue="formal"></nz-option>
            </nz-select>
          </div>
          <!-- <div class="field-block inline-field wide">
          <label class="inline-label">{{'ContactList.AccountExpiredDate' | translate}}</label>
          <nz-range-picker formControlName="expiredDateRange" [nzFormat]="dateFormat"></nz-range-picker>
        </div> -->
          <div class="condition-actions">
            <button nz-button nzType="primary" type="button" class="default-button" [disabled]="loading"
              (click)="onSearchVendor()">{{ loading ? ('ContactList.Searching' | translate) : ('ContactList.Search' |
              translate) }}</button>
            <button nz-button nzType="default" type="button" class="default-button" style="margin-left:8px;"
              [disabled]="loading || (vendorList?.length||0)===0" (click)="onExportVendor()"><span nz-icon
                nzType="export" nzTheme="outline"></span>{{ 'Export' | translate }}</button>
          </div>
        </div>
      </form>
      <!-- 客户条件区 回收商-->
      <form nz-form *ngIf="toNumber(activeTabIndex) === 1" [formGroup]="customerForm">
        <div class="row-with-spacing">
          <div class="field-block inline-field">
            <label class="inline-label">{{'ContactList.CustomerCode' | translate}}</label>
            <input nz-input formControlName="customerCode" [nzAutocomplete]="autoCustomerCode"
              (input)="onCustomerCodeInput($event.target.value)" />
            <nz-autocomplete #autoCustomerCode>
              <nz-auto-option *ngFor="let option of customerCodeOptionList" [nzValue]="option.supplierId">
                {{ option.supplierId }} - {{ option.supplierName }}
              </nz-auto-option>
            </nz-autocomplete>
          </div>
          <div class="field-block inline-field">
            <label class="inline-label">{{'ContactList.CustomerName' | translate}}</label>
            <input nz-input formControlName="customerName" [nzAutocomplete]="autoCustomerName"
              (input)="onCustomerNameInput($event.target.value)" />
            <nz-autocomplete #autoCustomerName>
              <nz-auto-option *ngFor="let option of customerNameOptionList" [nzValue]="option.supplierName">
                {{ option.companyCode }} - {{ option.supplierName }}
              </nz-auto-option>
            </nz-autocomplete>
          </div>
          <div class="field-block inline-field">
            <label class="inline-label">{{'Account' | translate}}</label>
            <input nz-input formControlName="account" />
          </div>
          <div class="field-block inline-field short">
            <label class="inline-label">{{'ContactList.IdmAccountStatus' | translate}}</label>
            <nz-select formControlName="fndaAccountStatus" nzAllowClear nzPlaceHolder="ALL">
              <nz-option nzLabel="ALL" nzValue=""></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountLocked' | translate" nzValue="locked"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountEntraInvalid' | translate" nzValue="entraExpired"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountWaitingVendor' | translate" nzValue="waitingVendor"></nz-option>
              <nz-option [nzLabel]="'ContactList.AccountActive' | translate" nzValue="active"></nz-option>
            </nz-select>
          </div>
          <div class="field-block inline-field short">
            <label class="inline-label">{{'ContactList.PermissionStatus' | translate}}</label>
            <nz-select formControlName="accountStatus" nzAllowClear nzPlaceHolder="ALL">
              <nz-option nzLabel="ALL" nzValue=""></nz-option>
              <nz-option [nzLabel]="'ContactList.Enabled' | translate" nzValue="valid"></nz-option>
              <nz-option [nzLabel]="'ContactList.Disabled' | translate" nzValue="invalid"></nz-option>
              <nz-option [nzLabel]="'ContactList.TransferredToOfficial' | translate" nzValue="formal"></nz-option>
            </nz-select>
          </div>
          <div class="condition-actions">
            <button nz-button nzType="primary" type="button" class="default-button" [disabled]="loading"
              (click)="onSearchCustomer()">{{ loading ? ('ContactList.Searching' | translate) : ('ContactList.Search'
              |
              translate) }}</button>
            <button nz-button nzType="default" type="button" class="default-button" style="margin-left:8px;"
              [disabled]="loading || (customerList?.length||0)===0" (click)="onExportCustomer()"><span nz-icon
                nzType="export" nzTheme="outline"></span>{{ 'Export' | translate }}</button>
          </div>
        </div>
      </form>
    </div>
    <nz-card style="margin-top: 12px;">
      <div class="table-header"
        style="display:flex; justify-content:flex-start; align-items:center; margin-bottom:8px;">
        <div class="title" style="font-size:16px; font-weight:600;">{{'ContactList.SupplierCustomerAccountList' |
          translate}}</div>
      </div>
      <!-- 来宾厂商列表：欄位調整 -->
      <nz-table *ngIf="toNumber(activeTabIndex)===2" [nzData]="guestVendorList" [nzScroll]="{ x: '3000px' }"
        nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]="false" [nzPageSize]="pageSizeGV"
        [nzPageIndex]="pageIndexGV">
        <thead>
          <tr>
            <th style="text-align:center;min-width:160px;">{{'ContactList.GuestCode' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.SupplierName' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.SupplierAddress' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Background' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.AccountStatus' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.PermissionStatus' | translate}}</th>
            <th style="min-width:170px;">{{'ContactList.ContactEmail' | translate}}</th>
            <th style="min-width:150px;">{{'ContactList.ContactMobile' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactChineseName' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactEnglishName' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactCompanyPhone' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.PicId' | translate}}</th>
            <th style="min-width:140px;">{{'LastLogInDate' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Creator' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.CreationTime' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Modifier' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ModificationTime' | translate}}</th>
            <th nzRight="120px" style="min-width:220px;">{{'ContactList.VcfCode' | translate}}</th>
            <th nzRight="0px" style="min-width:120px;text-align:center;">{{'ContactList.AccountSwitch' |
              translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of guestVendorList; let i=index">
            <td style="text-align:center;">{{data.supplierId}}</td>
            <td>{{data.supplierName}}</td>
            <td>{{data.supplierAddress || ''}}</td>
            <td>{{data.background || ''}}</td>
            <td>{{ data.accountStatusKey ? (data.accountStatusKey | translate) : '' }}</td>
            <td>{{ data.permissionStatusKey ? (data.permissionStatusKey | translate) : '' }}</td>
            <td>{{data.vendorMail || data.majorEmail}}</td>
            <td>{{data.vendorContact}}</td>
            <td>{{data.contactChineseName || ''}}</td>
            <td>{{data.contactEnglishName || ''}}</td>
            <td>{{data.companyPhone || ''}}</td>
            <td>{{data.picId || ''}}</td>
            <td>{{ data.lastLogin | utcToLocal }}</td>
            <td>{{data.creatorName || data.creatorId || ''}}</td>
            <td>{{data.creationTime ? (data.creationTime | date:'yyyy/MM/dd HH:mm:ss') : ''}}</td>
            <td>{{data.lastModifierName || data.lastModifierId || ''}}</td>
            <td>{{data.lastModificationTime ? (data.lastModificationTime | date:'yyyy/MM/dd HH:mm:ss') : ''}}</td>
            <td nzRight="120px">
              <ng-container *ngIf="editingGuestVendorCode === data.supplierId; else viewVcf">
                <div style="display:flex; flex-direction:column; align-items:flex-start; gap:6px; max-width:200px;">
                  <input nz-input [(ngModel)]="editingVcfCode" maxlength="10" style="width:180px;"
                    [disabled]="vcfSaving" />
                  <div style="display:flex; gap:6px;">
                    <button nz-button nzType="primary" nzSize="small" (click)="saveGuestVendorVcfCode(data)"
                      [disabled]="vcfSaving" [nzLoading]="vcfSaving">{{'ContactList.Save' | translate}}</button>
                    <button nz-button nzType="default" nzSize="small" (click)="cancelEditGuestVendor()"
                      [disabled]="vcfSaving">{{'ContactList.Cancel' | translate}}</button>
                  </div>
                </div>
              </ng-container>
              <ng-template #viewVcf>
                <div style="display:inline-flex; align-items:center; gap:8px;">
                  <span>{{data.vcfCode || ''}}</span>
                  <button *ngIf="toNumber(data.status)===1" nz-button nzType="link" nzSize="small"
                    (click)="startEditGuestVendor(data)">{{'ContactList.Maintain' | translate}}</button>
                </div>
              </ng-template>
            </td>
            <td nzRight="0px" style="text-align:center;">
              <nz-switch *ngIf="data.picId === userId || isShowAccountSwitch" [ngModel]="data.isenabl"
                (ngModelChange)="onAccountSwitch($event, data)" [nzDisabled]="data.status==2"></nz-switch>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <!-- 来宾客户列表（列精简与重排） -->
      <nz-table *ngIf="toNumber(activeTabIndex)===3" [nzData]="guestCustomerList" [nzScroll]="{ x: '3000px' }"
        nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]="false" [nzPageSize]="pageSizeGC"
        [nzPageIndex]="pageIndexGC">
        <thead>
          <tr>
            <th style="text-align:center;min-width:160px;">{{'ContactList.GuestCode' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.CustomerName' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.CustomerAddress' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Background' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.AccountStatus' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.PermissionStatus' | translate}}</th>
            <th style="min-width:220px;">{{'ContactList.CustomerAccount' | translate}}</th>
            <th style="min-width:150px;">{{'ContactList.ContactMobile' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactChineseName' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactEnglishName' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactCompanyPhone' | translate}}</th>
            <th style="min-width:140px;">{{'LastLogInDate' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Creator' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.CreationTime' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Modifier' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ModificationTime' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.PicId' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.PicName' | translate}}</th>
            <th nzRight="120px" style="min-width:120px;">{{'ContactList.VcfCode' | translate}}</th>
            <th nzRight="0px" style="min-width:120px;text-align:center;">{{'ContactList.AccountSwitch' |
              translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of guestCustomerList; let i=index">
            <td style="text-align:center;">{{data.supplierId}}</td>
            <td>{{data.supplierName}}</td>
            <td>{{data.customerAddress || ''}}</td>
            <td>{{data.background || ''}}</td>
            <td>{{ data.accountStatusKey ? (data.accountStatusKey | translate) : '' }}</td>
            <td>{{ data.permissionStatusKey ? (data.permissionStatusKey | translate) : '' }}</td>
            <td>{{data.account || data.vendorMail}}</td>
            <td>{{data.vendorContact || data.contactMobile || ''}}</td>
            <td>{{data.contactChineseName || '' }}</td>
            <td>{{data.contactEnglishName || ''}}</td>
            <td>{{data.companyPhone || ''}}</td>
            <td>{{ data.lastLogin | utcToLocal }}</td>
            <td>{{data.creatorUserName || data.creatorId || ''}}</td>
            <td>{{data.creationTime ? (data.creationTime | date:'yyyy/MM/dd HH:mm:ss') : ''}}</td>
            <td>{{data.lastModifierUserName || data.lastModifierId || ''}}</td>
            <td>{{data.lastModificationTime ? (data.lastModificationTime | date:'yyyy/MM/dd HH:mm:ss') : ''}}</td>
            <td>{{data.sourcer || ''}}</td>
            <td>{{data.sourcerName || ''}}</td>
            <td nzRight="120px">
              <ng-container *ngIf="editingGuestCustomerCode === data.supplierId; else viewCustomerVcf">
                <div style="display:flex; flex-direction:column; align-items:flex-start; gap:6px; max-width:200px;">
                  <input nz-input [(ngModel)]="editingCustomerVcfCode" maxlength="10" style="width:180px;"
                    [disabled]="vcfCustomerSaving" />
                  <div style="display:flex; gap:6px;">
                    <button nz-button nzType="primary" nzSize="small" (click)="saveGuestCustomerVcfCode(data)"
                      [disabled]="vcfCustomerSaving" [nzLoading]="vcfCustomerSaving">{{'ContactList.Save' |
                      translate}}</button>
                    <button nz-button nzType="default" nzSize="small" (click)="cancelEditGuestCustomer()"
                      [disabled]="vcfCustomerSaving">{{'ContactList.Cancel' | translate}}</button>
                  </div>
                </div>
              </ng-container>
              <ng-template #viewCustomerVcf>
                <div style="display:inline-flex; align-items:center; gap:8px;">
                  <span>{{data.vcfCode || ''}}</span>
                  <button *ngIf="toNumber(data.status)===1" nz-button nzType="link" nzSize="small"
                    (click)="startEditGuestCustomer(data)">{{'ContactList.Maintain' | translate}}</button>
                </div>
              </ng-template>
            </td>
            <td nzRight="0px" style="text-align:center;">
              <nz-switch *ngIf="data.sourcer === userId || isShowAccountSwitch" [ngModel]="data.isenabl"
                (ngModelChange)="onAccountSwitch($event, data)" [nzDisabled]="data.status==2"></nz-switch>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <!-- 厂商列表 -->
      <nz-table *ngIf="toNumber(activeTabIndex)===0" [nzData]="vendorList" [nzScroll]="{ x: '1700px' }"
        nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]="false" [nzPageSize]="pageSizeV"
        [nzPageIndex]="pageIndexV">
        <thead>
          <tr>
            <th style="text-align:center;min-width:90px;">{{'ContactList.Site' | translate}}</th>
            <th style="text-align:center;min-width:90px;">{{'ContactList.CompanyCode' | translate}}</th>
            <th style="text-align:center;min-width:110px;">{{'ContactList.SupplierCode' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.SupplierName' | translate}}</th>
            <th style="min-width:200px;">{{'ContactList.AccountStatus' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.PermissionStatus' | translate}}</th>
            <th style="min-width:200px;">{{'ContactList.SupplierAccount' | translate}}</th>
            <th style="min-width:150px;">{{'ContactList.SupplierContact' | translate}}</th>
            <th style="min-width:140px;">{{'LastLogInDate' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Creator' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.CreationTime' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Modifier' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ModificationTime' | translate}}</th>
            <th nzRight="0px" style="text-align:center;min-width:120px;">{{'ContactList.AccountSwitch' |
              translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of vendorList; let i=index">
            <td style="text-align:center;">{{data.site}}</td>
            <td style="text-align:center;">{{data.companyCode}}</td>
            <td style="text-align:center;">{{data.supplierId}}</td>
            <td>{{data.supplierName}}</td>
            <td>{{ data.accountStatusKey ? (data.accountStatusKey | translate) : '' }}</td>
            <td>{{ data.permissionStatusKey ? (data.permissionStatusKey | translate) : '' }}</td>
            <td>{{data.vendorMail || data.majorEmail || data.account}}</td>
            <td>{{data.vendorContact}}</td>
            <td>{{ data.lastLogin | utcToLocal }}</td>
            <td>{{data.creatorUserName || data.creatorId || ''}}</td>
            <td>{{data.creationTime ? (data.creationTime | date:'yyyy/MM/dd HH:mm:ss') : ''}}</td>
            <td>{{data.lastModifierUserName || data.lastModifierId || ''}}</td>
            <td>{{data.lastModificationTime ? (data.lastModificationTime | date:'yyyy/MM/dd HH:mm:ss') : ''}}</td>
            <td nzRight="0px" style="text-align:center;">
              <nz-switch [ngModel]="data.isenabl" (ngModelChange)="onAccountSwitch($event, data)"
                [nzLoading]="switchLoadingMap[data.supplierId + '_0']" [nzDisabled]="switchLoadingMap[data.supplierId + '_0']">
              </nz-switch>
          </tr>
        </tbody>
      </nz-table>
      <!-- 一般客戶列表（欄位重構） -->
      <nz-table *ngIf="toNumber(activeTabIndex)===1" [nzData]="customerList" [nzScroll]="{ x: '3000px' }"
        nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]="false" [nzPageSize]="pageSizeC"
        [nzPageIndex]="pageIndexC">
        <thead>
          <tr>
            <th style="text-align:center;min-width:100px;">{{'ContactList.CompanyCode' | translate}}</th>
            <th style="text-align:center;min-width:240px;">{{'ContactList.CustomerCode' | translate}}</th>
            <th style="text-align:center;min-width:200px;">{{'ContactList.CustomerName' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.AccountStatus' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.PermissionStatus' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.Contact' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactChineseName' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactPhone' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ContactMobile' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.ContactFax' | translate}}</th>
            <th style="min-width:240px;">{{'ContactList.CustomerAccount' | translate}}</th>
            <th style="min-width:140px;">{{'LastLogInDate' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Creator' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.CreationTime' | translate}}</th>
            <th style="min-width:120px;">{{'ContactList.Modifier' | translate}}</th>
            <th style="min-width:140px;">{{'ContactList.ModificationTime' | translate}}</th>
            <th style="min-width:160px;">{{'ContactList.ExpiredReason' | translate}}</th>
            <th style="text-align:center;min-width:100px;">{{'ContactList.Site' | translate}}</th>
            <th nzRight="0px" style="text-align:center;min-width:120px;">{{'ContactList.AccountSwitch' |
              translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of customerList; let i=index">
            <td style="text-align:center;">{{data.companyCode}}</td>
            <td>{{data.supplierId || ''}}</td>
            <td>{{data.supplierName || ''}}</td>
            <td>{{ data.accountStatusKey ? (data.accountStatusKey | translate) : '' }}</td>
            <td>{{ data.permissionStatusKey ? (data.permissionStatusKey | translate) : '' }}</td>
            <td>{{data.vendorContact || ''}}</td>
            <td>{{ getContactChineseName(data) }}</td>
            <td>{{data.companyPhone || ''}}</td>
            <td>{{data.contactMobile || ''}}</td>
            <td>{{data.contactFax || ''}}</td>
            <td>{{data.account || data.vendorMail}}</td>
            <td>{{data.lastLogin | utcToLocal }}</td>
            <td>{{data.creatorUserName || data.creatorId || ''}}</td>
            <td>{{data.creationTime ? (data.creationTime | date:'yyyy/MM/dd HH:mm:ss') : ''}}</td>
            <td>{{data.lastModifierUserName || data.lastModifierId || ''}}</td>
            <td>{{data.lastModificationTime ? (data.lastModificationTime | date:'yyyy/MM/dd HH:mm:ss') : ''}}</td>
            <td>{{data.expiredReason || data.disableReason || ''}}</td>
            <td style="text-align:center;">{{data.site}}</td>
            <td nzRight="0px" style="text-align:center;">
              <nz-switch [ngModel]="data.isenabl" (ngModelChange)="onAccountSwitch($event, data)"></nz-switch>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <!-- 统一底部右侧分页容器：移至所有表格之后，避免在部分标签上方显示 -->
      <div style="display:flex; justify-content:flex-end; margin-top:12px;">
        <ng-container [ngSwitch]="activeTabIndex">
          <nz-pagination *ngSwitchCase="0" [nzSize]="'small'" nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50, 100]"
            [nzPageIndex]="pageIndexV" [nzPageSize]="pageSizeV" [nzTotal]="totalV"
            (nzPageIndexChange)="onPageIndexChangeV($event)" (nzPageSizeChange)="onPageSizeChangeV($event)"
            nzShowSizeChanger nzShowQuickJumper></nz-pagination>
          <nz-pagination *ngSwitchCase="1" [nzSize]="'small'" nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50, 100]"
            [nzPageIndex]="pageIndexC" [nzPageSize]="pageSizeC" [nzTotal]="totalC"
            (nzPageIndexChange)="onPageIndexChangeC($event)" (nzPageSizeChange)="onPageSizeChangeC($event)"
            nzShowSizeChanger nzShowQuickJumper></nz-pagination>
          <nz-pagination *ngSwitchCase="2" [nzSize]="'small'" nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50, 100]"
            [nzPageIndex]="pageIndexGV" [nzPageSize]="pageSizeGV" [nzTotal]="totalGV"
            (nzPageIndexChange)="onPageIndexChangeGV($event)" (nzPageSizeChange)="onPageSizeChangeGV($event)"
            nzShowSizeChanger nzShowQuickJumper></nz-pagination>
          <nz-pagination *ngSwitchCase="3" [nzSize]="'small'" nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50, 100]"
            [nzPageIndex]="pageIndexGC" [nzPageSize]="pageSizeGC" [nzTotal]="totalGC"
            (nzPageIndexChange)="onPageIndexChangeGC($event)" (nzPageSizeChange)="onPageSizeChangeGC($event)"
            nzShowSizeChanger nzShowQuickJumper></nz-pagination>
        </ng-container>
      </div>
    </nz-card>
  </nz-spin>
  <ng-template #guestVendorTab>
    <span class="tab-title">{{'ContactList.GuestVendor' | translate}}</span>
  </ng-template>
  <ng-template #guestCustomerTab>
    <span class="tab-title">{{'ContactList.GuestCustomer' | translate}}</span>
  </ng-template>
  <ng-template #vendorTab>
    <span class="tab-title">{{'ContactList.Vendor' | translate}}</span>
  </ng-template>
  <ng-template #customerTab>
    <span class="tab-title">{{'ContactList.Customer' | translate}}</span>
  </ng-template>
